const ease = [0.165, 0.84, 0.44, 1]

const animations = {
  main: {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  },
  quoteIcon: {
    hidden: {
      opacity: 0,
      scale: 0,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        delay: 0.5,
        duration: 0.75,
        ease,
      },
    },
  },
  quoteText: {
    hidden: {
      opacity: 0,
      y: -70,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        delay: 0.5,
        duration: 0.75,
        ease,
      },
    },
  },
  quoteSource: {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        delay: 1,
      },
    },
  },
  quoteLine: {
    hidden: {
      opacity: 0,
      scaleX: 0,
    },
    visible: {
      opacity: 1,
      scaleX: 1,
      transition: {
        delay: 1,
        ease,
        duration: 0.75,
      },
    },
  },
}

export default animations
